<script lang="ts" setup>
import type { JobItem } from '~/models/Job'
import { useJobs } from '~/store/job'

interface Props {
  item: JobItem
}

const props = defineProps<Props>()
const otherJob = ref<JobItem[]>([])
const job = computed(() => props.item as JobItem)

fetchSimilarJob()
async function fetchSimilarJob() {
  const payload = {
    country: useGetSubdomain(),
    from: 0,
    term: job.value?.title,
    sort: 'date',
    size: 4,
    type: 'simple_title_with_similar_titles_search',
  }
  const { data, error } = await useSearchApi('/jobs/search', {
    initialCache: false,
    method: 'POST',
    body: payload,
    key: 'fetch_similar_job',
  })
  if (!error.value && data.value) {
    const resp = data.value as { total: number; hits?: JobItem[] }
    otherJob.value = resp?.hits.filter(item => item.id !== props.item?.id)
    if (!isEmpty(resp?.hits))
      tracking('job_page_similarjob_shown', { similar_job_logic: 'specific', similar_job_result: resp.hits.length })
    else
      tracking('job_page_similarjob_shown', { similar_job_logic: 'empty_state', similar_job_result: 'no_job' })
  }
}

function tracking(eventName: string, eventModel: {}) {
  useSetTracking(eventName, eventModel)
}
</script>

<template>
  <div v-if="!isEmpty(otherJob)" class="bg-white rounded-md shadow-sm px-4 lg:px-6 py-6">
    <div class="text-xl font-bold mb-4">
      Similar Jobs
    </div>
    <div class="grid gap-y-4">
      <BrowsejobsJobCard v-for="(jobItem, idx) in otherJob" :key="idx" impression-source="job-detail" :item="jobItem" :job-id="jobItem.job_id" />
    </div>
  </div>
</template>
